import {BILLING_TYPE} from "../../../CAMPAIGN/ms/common/CommonConst";

export const TARGET_TYPE = {
    NONE_TARGET: 1,
    DEMOGRA: 3,
    CUSTOM: 5,
    RETAGE: 6,
    GEOTARGET: 7,
    GEOTARGET_DEMOGRA: 17,
}
export const TARGETING_DISPLAY_POS = {
    1: TARGET_TYPE.DEMOGRA,
    2: TARGET_TYPE.CUSTOM,
    3: TARGET_TYPE.RETAGE,
    4: TARGET_TYPE.GEOTARGET,
    5: TARGET_TYPE.GEOTARGET_DEMOGRA,
}

export const options_ms_campaign_type = [
    {value: 1, label: "メッセージS"},
    {value: 2, label: "リアルタイムメッセージS"},
];

export const MSG = {
    SUCCESS_POST_AD_GROUP: "広告グループ情報作成に成功しました。",
    SUCCESS_PUT_AD_GROUP: "広告グループ情報更新に成功しました。",

    ERR_TRACKER_ID: "トラッカーIDが指定されていません。",
    ERR_GET_ADGROUP: "広告グループ情報取得に失敗しました。",
    ERR_GET_CAMPAIGN: "キャンペーン情報取得に失敗しました。",
    ERR_GET_ACCOUNT: "アカウント情報取得に失敗しました。",
    ERR_GET_AUDIENCE: "オーディエンスリスト情報のデータ取得に失敗しました。",
    ERR_GET_CUSTOM: "カスタムリスト情報のデータ取得に失敗しました。",
    ERR_GET_AFINITY: "アフィニティリスト情報のデータ取得に失敗しました。",
    ERR_GET_GEOSEGMENT: "ジオセグメントリスト情報のデータ取得に失敗しました。",
    ERR_POST_ADGROUP: "広告グループ情報作成に失敗しました。",
    ERR_PUT_ADGROUP: "広告グループ情報更新に失敗しました。",
    ERR_GET_ADVERTISEMENT: "広告情報取得に失敗しました。",
}

export const AdGroupProcessType = {
    create: "create",
    edit: "edit",
}

export const CHECKED = 1;
export const INIT_STR = "";
export const INIT_NUMBER = 0;

export const STATUS_ARCHIVE = 6;

export const AD_TYPE = {
    MAIL: 1,
}

export const BID_CTRY = {
    Max_CPC: 1,
    Ideal_CPA: 2,
    Manual_CPM: 3,
}

export const CHARGE_TYPE_TO_BID_CTGRY_TRANSFER_MAP = new Map<number, number>(
    [
        [BILLING_TYPE.CPC, BID_CTRY.Max_CPC],
        [BILLING_TYPE.CPM, BID_CTRY.Manual_CPM],
    ]
);

export const RESULT_KBN = {
    SUCCESS: 0,
    INFO: 1,
    ERROR: -9,
}

export const RESULT_ACCOUNT_ERROR = -1
export const RESULT_AUDIENCE_ERROR = -1
export const RESULT_CUSTOM_ERROR = -1

export const options_ms_ad_target = [
    {value: TARGET_TYPE.NONE_TARGET, label: "ﾉﾝﾀｰｹﾞﾃｨﾝｸﾞ"},
    {value: TARGET_TYPE.DEMOGRA, label: "ﾃﾞﾓｸﾞﾗ・ｱﾌｨﾆﾃｨｶﾃｺﾞﾘ"},
    {value: TARGET_TYPE.CUSTOM, label: "ｶｽﾀﾑｾｸﾞﾒﾝﾄ"},
    {value: TARGET_TYPE.RETAGE, label: "配信ｵｰﾃﾞｨｴﾝｽ設定（ﾘﾀｰｹﾞﾃｨﾝｸﾞ）"},
    {value: TARGET_TYPE.GEOTARGET, label: "ｼﾞｵﾀｰｹﾞﾃｨﾝｸﾞ"},
    {value: TARGET_TYPE.GEOTARGET_DEMOGRA, label: "ﾃﾞﾓｸﾞﾗ・ｼﾞｵﾀｰｹﾞﾃｨﾝｸﾞ"},
];

export const options_ms_ad_target_for_display = [
    {value: options_ms_ad_target[0].value, label: ""},
    {value: options_ms_ad_target[1].value, label: "D,A"},
    {value: options_ms_ad_target[2].value, label: "C"},
    {value: options_ms_ad_target[3].value, label: "R"},
    {value: options_ms_ad_target[4].value, label: "G"},
    {value: options_ms_ad_target[5].value, label: "D,G"},
];

export const options_ms_os_type = [
    {value: 1, label: "iOS/Android"},
    {value: 2, label: "Android"},
    {value: 3, label: "iOS"},
];
export const options_ms_ad_type_jp = [
    {value: 1, label: 'メール広告'},
    /*    {value: 2, label: 'メール動画広告'},*/
];

// アフィニティカテゴリの上限数
export const AFFINITY_CATEGORY_MAX_MS = 30